module.exports = __webpack_public_path__ + "static/heavy_yuleba2-565dd15fcd47751d84f2cb4ce06399c6.jpg";